import { render, staticRenderFns } from "./TeacherPersonalData.vue?vue&type=template&id=36791886&"
import script from "./TeacherPersonalData.vue?vue&type=script&lang=js&"
export * from "./TeacherPersonalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports